// extracted by mini-css-extract-plugin
module.exports = {"root":"FormTimeSelect_root__1LmJZ","item":"FormTimeSelect_item__2RcuL","separator":"FormTimeSelect_separator__3tqAD"};